





























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import AvatarDescription from "@/components/AvatarDescription";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "LivePreviewItem",
  components: { BaseImage, AvatarDescription, BaseIconButton },
  props: {
    user: { type: Object as PropType<UserPublicData | User>, required: true },
    file: { type: Object as PropType<FileData | null>, default: null },
    showDeleteButton: { type: Boolean, default: false },
    deleting: { type: Boolean, default: false },
    isPrivateLive: { type: Boolean, default: false },
  },
  setup(props) {
    const imageSrc = computed(() => {
      if (props.file && (props.file.fileId.type === "livepreview_manual" || !props.isPrivateLive)) {
        return getMediaThumbnailUrl(props.file, props.file.urlPart, "720p");
      }
      return "/img/live-preview-default.png";
    });

    return { imageSrc };
  },
});
